import request from '@/utils/request';
import Qs from 'qs';

const baseAdminURL = process.env.VUE_APP_ADMIN;
/**
 * 获取组织机构
 * @param parentId
 */
export const getOrganizationTree = (parentId) => {
  // return request.get('/user/organization/getOrganizationTree', { params: { parentId: parentId }});
  return request({
    method: 'GET',
    url: '/organization/getOrganizationTree',
    params: { parentId: parentId },
    baseURL: baseAdminURL
  });
};

/**
 * 删除组织机构
 * @param orgId
 * @returns
 */
export const removeOrganization = (orgId) => {
  // return request.post('/user/organization/delete', Qs.stringify({ orgId: orgId }));
  return request({
    method: 'post',
    url: '/organization/delete',
    data: Qs.stringify({ orgId: orgId }),
    baseURL: baseAdminURL
  });
};

/**
 * 添加组织机构
 * @param data
 * @returns
 */
export const addOrganization = (data) => {
  return request({
    method: 'post',
    url: '/organization/add',
    data,
    baseURL: baseAdminURL
  });
};

/**
 * 编辑组织机构
 * @param data
 * @returns
 */
export const editOrganization = data => {
  return request({
    method: 'post',
    url: '/organization/edit',
    data,
    baseURL: baseAdminURL
  });
};
